import * as React from 'react';
import {useSelector} from 'react-redux';

import {useSoundEffect, type MediaSpec} from 'src/hooks/useAudio';
import {useReleaseFlag} from 'src/hooks/product-flags';


type Props = {
  media: MediaSpec | MediaSpec[];
  playId: unknown;
  soundSetting: boolean;
  playOnMount?: boolean;
};

export default function ChatSoundEffect(props: Props) {
  const {soundSetting, playId, ...restProps} = props;

  const soundEffectsEnabledSetting = useSelector(
    (state) => state.agentSettings.messagingSound,
  );
  const soundAndEmailSettingsReleaseFlag = useReleaseFlag(
    'messagingSoundEmailSettingsChangeToPhoneSetAssignment',
  );

  const soundEffectsEnabled = soundAndEmailSettingsReleaseFlag
    ? soundSetting
    : soundEffectsEnabledSetting;

  useSoundEffect({
    ...restProps,
    playId,
    // @ts-expect-error - TS2339 - Property 'messagingSound' does not exist on type 'AgentSettingsState'.
    soundEffectsEnabled,
  });

  return null;
}
